<template>
	<div class="big_box">
		<div class="head">
			<img src="@/assets/headImg/headimg.jpg" style="width: 100%;
			vertical-align:top;" class="lunbo1" />
			<img src="@/assets/lunbo.jpg" style="width: 100%;" class="lunbo2">
			<div class="retrun" @click="retrun">
				返回首页
			</div>
		</div>

		<el-row style="width: 100%;">

			<el-col :xs="22" :sm="24" :md="24" :lg="24" :xl="24" style="margin-left: 50%;transform: translateX(-50%);">
				<el-card>
					<h3 style="font-size: 30px;">团队参会注册</h3>
					<h4>
						<el-link type="primary" href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E4%BC%81%E4%B8%9A%E5%9B%A2%E9%98%9F%E6%B3%A8%E5%86%8C%E4%BF%A1%E6%81%AF%E6%94%B6%E9%9B%86%E8%A1%A8.xlsx"
						 icon="el-icon-download">
							下载企业团队注册信息收集表</el-link>
						<div style="height: 1.25rem;"></div>
						<el-link type="primary" href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E5%A7%94%E5%91%98%E6%8E%A8%E8%8D%90%E5%9B%A2%E9%98%9F%E6%B3%A8%E5%86%8C%E4%BF%A1%E6%81%AF%E6%94%B6%E9%9B%86%E8%A1%A8.xlsx"
						 icon="el-icon-download">
							下载委员推荐团队注册信息收集表</el-link>
					</h4>
					<h4>1.上传excel表格</h4>
					<h4>2.上传完成后，点击注册</h4>
					<el-row >
						<el-col :span="5" :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<el-upload action=" " :multiple="false" :on-change="handleUploadChange" :file-list="uploadFileList"
							 :http-request="ossupload" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
								<el-button size="mini" type="primary" icon="el-icon-upload">上传团队资料</el-button>
							</el-upload>
						</el-col>
						<el-col :span="5" :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
							<el-button size="mini" type="primary" icon="el-icon-s-home" :disabled=disabled @click="rg">注册</el-button>
						</el-col>
					</el-row>
				</el-card>
				<div v-show="!disabled" style="font-size: 18px;">
					提交注册<span style="color: #409EFF;">{{obj.count}}</span>人，成功<span style="color: #67C23A;">{{succCount}}</span>人，失败<span
					 style="color: #F56C6C;">{{errorCount}}</span>人。
				</div>
				<p style="color: #606266;">本次错误详细信息如下：</p>
				<el-table :data="tableData" border style="width: 100%" :cell-class-name="addclass">
					<el-table-column prop="0" label="序号" width="80">
					</el-table-column>
					<el-table-column prop="1" label="姓名" width="150">
					</el-table-column>
					<el-table-column prop="3" label="手机号" width="150">
					</el-table-column>
					<el-table-column prop="4" label="邮箱" width="150">
					</el-table-column>
					<el-table-column prop="18" label="说明" fixed="right">
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-dialog title="提示" :visible.sync="dialogVisible" :close-on-click-modal=false width="80%" :before-close="()=>{dialogVisible=false}">
			<el-form status-icon class="demo-ruleForm">
				<el-form-item label="提交人姓名">
					<el-input v-model="name" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="readExcelRegister" style="width: 100%;margin-top: 1.25rem;">提交</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<logocom class="isshow2"></logocom>
	</div>
</template>

<script>
	import OSS from 'ali-oss';
	import logocom from '@/components/logo/logo.vue';
	export default {
		data() {
			return {
				succCount: '',
				errorCount: '',
				tableData: [],
				obj: {},
				fileUrl: '',
				disabled: true,
				ossUrl: "http://bisc2021.ganzhiyu.com/",
				showProgress: '',
				progress: '',
				uploadFileList: [],
				name: '',
				dialogVisible: false,
			}
		},
		components: {
			logocom
		},
		methods: {
			retrun: function() {
				this.$router.push({
					path: '/'
				})
			},
			addclass(row) {
				if (row.columnIndex == 4) {
					return 'error'
				}
			},
			rg() {
				this.dialogVisible = true;
			},
			readExcelRegister() {
				this.$api.readExcelRegister({
					fileUrl: this.fileUrl,
					submitUser: this.name,
				}, (res) => {
					if (res.data.rc == this.$util.RC.SUCCESS) {
						this.obj = JSON.parse(res.data.c)
						this.succCount = this.obj.succ == null ? 0 : this.obj.succ.length
						this.errorCount = this.obj.error == null ? 0 : this.obj.error.length
						this.tableData = this.obj.error
						this.$message.success("请求成功：可查看详细信息")
						this.dialogVisible = false
					} else {
						this.$message.error(res.data.rm)
					}
				});
			},
			handleUploadChange(file, fileList) {
				this.uploadFileList = fileList.slice(-3);
			},
			ossupload(file) {
				this.disabled = true
				const ak = 'LTAI4GDL9h' + 'dhWKe4Z293ntH6';
				const aks = 'F8FuqQZAuG1oHE' + 'dSxnkt1hDdpxEhXs';
				const client = new OSS({
					region: 'oss-cn-hangzhou',
					accessKeyId: ak,
					accessKeySecret: aks,
					bucket: 'ganzhiyu'
				});
				const xfname = `/upload-file/teamRegisterExcel/${new Date().getTime()+'_'+file.file.name}`;
				const that = this;
				client
					.multipartUpload(xfname, file.file, {
						progress: function(p) {
							//p进度条的值
							that.showProgress = true;
							that.progress = Math.floor(p * 100);
						}
					})
					.then(result => {
						//上传成功返回值，可针对项目需求写其他逻辑
						that.$message({
							message: '文件上传成功',
							type: 'success'
						});
						this.fileUrl = this.ossUrl + result.name;
						this.disabled = false
					})
					.catch(err => {
						that.$message.error('上传失败，请重试。');
						console.log('err:', err);
					});
			},
		}
	}
</script>

<style scoped>
	.retrun {
		margin: 20px 0;
		cursor: pointer;
		color: rgb(20, 90, 245);
		font-size: 1.125rem;
		font-weight: bold;
	}

	.retrun:hover {
		color: #49a8eb;
	}

	.el-row {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.el-col {
		border-radius: 4px;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}

	.error {
		color: red;
	}

	.big_box {
		width: 980px;
		margin: 0 auto;
	}

	.lunbo2 {
		display: none;
	}

	.isshow {
		visibility: hidden;
	}

	.isshow2 {
		display: none;
	}

	@media (max-width: 980px) {
		.head {
			width: 100%;
		}
	}

	@media (max-width: 680px) {
		.signin {
			width: 70%;
			margin: 0 auto;
		}
	}

	@media (max-width:500px) {
		.lunbo1 {
			display: none;
		}

		.big_box {
			width: 100%;
		}

		.lunbo2 {
			display: block;
			margin-bottom: 50px;
		}

		.isshow {
			visibility: visible;
		}

		.head {
			padding-right: 0;
		}

		.retrun {
			display: none;
		}

		.isshow2 {
			display: block;
		}

	}
</style>
